import type { IconProps } from './IconProps';

export const ChevronRightIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 6 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 6}
    height={props.height ?? 10}
    {...props}
  >
    <path
      d="M1 9L5 5L1 1"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
